import React from 'react';
import { Document as _Document, Page as _Page, Text as _Text } from '@react-pdf/renderer';
import {
  PdfTable as _PdfTable,
  PdfTableHeader as _PdfTableHeader,
  PdfTableCell as _PdfTableCell,
  PdfTableBody as _PdfTableBody,
  PdfDataTableCell as _PdfDataTableCell,
} from 'shared/pdf-data-table';
import { EnrollmentTransaction } from '../enrollment.types';
import dayjs from 'dayjs';
import { currencyFormatter } from 'shared/utils';

interface Props {
  cells: EnrollmentTransaction[];
}

const Document = _Document as any;
const Page = _Page as any;
const Text = _Text as any;
const PdfTable = _PdfTable as any;
const PdfTableHeader = _PdfTableHeader as any;
const PdfTableCell = _PdfTableCell as any;
const PdfTableBody = _PdfTableBody as any;
const PdfDataTableCell = _PdfDataTableCell as any;

// Create Document Component
function HsaPdf ({ cells }: Props) {
  return (
    <Document>
      <Page>
        <Text>Transactions</Text>
        <PdfTable
          data={cells}
        >
          <PdfTableHeader>
            <PdfTableCell>
              Posted
            </PdfTableCell>
            <PdfTableCell>
              Pay Date
            </PdfTableCell>
            <PdfTableCell>
              Amount
            </PdfTableCell>
            <PdfTableCell>
              Type
            </PdfTableCell>
            <PdfTableCell>
              Status
            </PdfTableCell>
          </PdfTableHeader>
          <PdfTableBody>
            {/* eslint-disable react/jsx-no-bind */}
            <PdfDataTableCell
              getContent={
                (r: EnrollmentTransaction) => dayjs(r.effectiveDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
            />
            <PdfDataTableCell
              getContent={
                (r: EnrollmentTransaction) => dayjs(r.incurredDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
              }
            />
            <PdfDataTableCell getContent={(r: EnrollmentTransaction) => currencyFormatter.format(r.amount)} />
            <PdfDataTableCell getContent={(r: EnrollmentTransaction) => r.type} />
            <PdfDataTableCell getContent={(r: EnrollmentTransaction) => r.referenceNumber} />
            {/* eslint-enable react/jsx-no-bind */}
          </PdfTableBody>
        </PdfTable>
      </Page>
    </Document>
  );
}

export default HsaPdf;
